module.exports = __webpack_public_path__ + "static/media/rate-1.686cea9d.svg";